module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_incertezza-small-4f0013ba58f9ef427b1c6efc5f81dcc8.png";